"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanifyPropertyValueSet = cleanifyPropertyValueSet;
const property_1 = require("@genesys/property");
const uom_1 = require("@genesys/uom");
const QuantityConversion = __importStar(require("../quantity-conversion"));
function cleanifyPropertyValueSet(pvs, definitions) {
    const propertyNames = property_1.PropertyValueSet.getPropertyNames(pvs);
    const dirtyProperties = propertyNames
        .map(p => {
        const amount = property_1.PropertyValueSet.getAmount(p, pvs);
        if (!amount) {
            return {
                name: p,
                clean: true,
                amount: amount,
                definition: undefined
            };
        }
        const definition = definitions.find(d => d.name === p);
        if (!definition || uom_1.Amount.isQuantity(definition.quantity, amount)) {
            return {
                name: p,
                clean: true,
                amount: amount,
                definition: undefined
            };
        }
        return {
            name: p,
            clean: false,
            amount: amount,
            definition: definition
        };
    })
        .filter(p => !p.clean);
    const cleaned = dirtyProperties.map(d => ({
        amount: QuantityConversion.convertQuantity(d.amount, d.definition.quantity, d.definition.conversionParameters),
        name: d.name
    }));
    const cleanPvs = cleaned.reduce((a, b) => property_1.PropertyValueSet.set(b.name, property_1.PropertyValue.fromAmount(b.amount), a), property_1.PropertyValueSet.Empty);
    return property_1.PropertyValueSet.merge(cleanPvs, pvs);
}
//# sourceMappingURL=index.js.map